import React, { useState } from "react";
import DealsDrilldownModal from "@/components/layouts/DealsDrilldownModal/DealsDrilldownModal";
import { UserData } from "@/entities/users/types";

export const withDealsDrilldown = <P extends object>(
  WrappedComponent: React.ComponentType<P>
) => {
  return function WithDealsDrilldown(props: P) {
    const [dealsModalUser, setDealsModalUser] = useState<UserData | null>(null);

    const handleScoreClick = (user: UserData | null) => {
      setDealsModalUser(user);
    };

    return (
      <>
        <WrappedComponent {...props} onScoreClick={handleScoreClick} />
        <DealsDrilldownModal
          user={dealsModalUser}
          setUser={setDealsModalUser}
        />
      </>
    );
  };
};
